<template>
  <div class="error-container" v-if="isError">
    <div class="heading-text">
      To create a proposal your wallet must contain 10,000 $VIBES
    </div>
    <div class="text">
      Your wallet currently does not contain the required amount. You can go to <strong> ALEX </strong> or <strong> StackSwap </strong> to purchase $VIBES tokens that will enable you to make a proposal.
    </div>
  </div>
  <div class="container" v-else>
    <div class="heading-text">
      Welcome Community Member!
    </div>
    <div class="text">
      You hold enough $VIBES to create a proposal. You’re tokens will be locked for the duration of the proposal and voting process (approx. 7 days). Thank you for your contribution to the community!
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProposalBanner',
  props: {
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.heading-text{
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  color: #000;
  text-align: center;
  font-size: 13px;
}

.text{
  font-style: normal;
  line-height: normal;
  color: #000;
  text-align: center;
  font-size: 12px;
}
.container{
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
  width: 100%;
  background-color: #c7f4fa;
  padding: 10px 18px;
  border-radius: 4px;
  border: 1px solid #31E5FF;
  margin-bottom: 20px;
}
.error-container{
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
  width: 100%;
  background-color: #f5cbcc;
  padding: 10px 18px;
  border-radius: 4px;
  border: 1px solid #E84142;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal-banner.vue